// extracted by mini-css-extract-plugin
export default {"overlay":"RB-z","bodyOpen":"SB-z","content":"TB-z","header":"UB-z","close":"VB-z","closeNoHeading":"WB-z"};